import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main'
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'

const model = (payload) => ({
  // columns
  id: payload.id,
  requisition_id: payload.requisition_id,
  supply_id: payload.supply_id,
  supply_amount: payload.supply_amount,
  supply_order_quantity: 0,
  supply_pending_quantity: payload.supply_amount
})
var crud = new Crud('RequisitionDetails', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  requisitionDetails: [],
  supplies: []
}

const mutations = {
  ...crud.mutations,
  SET_SUPPLIES ({ commit }, payload) {
    state.supplies = payload
  }
}

const actions = {
  ...crud.actions,
  async loadSupplies ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`supplies/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SUPPLIES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addRecord ({ commit }, payload) {
    const record = model(payload)

    app.$Progress.start()

    try {
      const response = await axios.post('requisition-details', record)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_RECORD', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.' + 'requisition_detail', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  requisitionDetails: state => state.requisitionDetails,
  supplies: state => state.supplies
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
